import { ChangeDetectionStrategy, Component, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'phx-modal-upsell-success-icon',
  template: `
    <svg xmlns="http://www.w3.org/2000/svg" width="56" height="56" viewBox="0 0 56 56" fill="none">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M37.9874 22.2374L25.0833 35.1415L18.0126 28.0708L20.4874 25.5959L25.0833 30.1918L35.5126 19.7626L37.9874 22.2374Z" fill="url(#paint0_linear_94762_18516)"/>
      <path fill-rule="evenodd" clip-rule="evenodd" d="M28 10.5C18.335 10.5 10.5 18.335 10.5 28C10.5 37.665 18.335 45.5 28 45.5C37.665 45.5 45.5 37.665 45.5 28C45.5 18.335 37.665 10.5 28 10.5ZM7 28C7 16.402 16.402 7 28 7C39.598 7 49 16.402 49 28C49 39.598 39.598 49 28 49C16.402 49 7 39.598 7 28Z" fill="url(#paint1_linear_94762_18516)"/>
      <defs>
        <linearGradient id="paint0_linear_94762_18516" x1="49" y1="28" x2="7" y2="28" gradientUnits="userSpaceOnUse">
          <stop stop-color="#144F21"/>
          <stop offset="0.5" stop-color="#228739"/>
          <stop offset="1" stop-color="#32C353"/>
        </linearGradient>
        <linearGradient id="paint1_linear_94762_18516" x1="49" y1="28" x2="7" y2="28" gradientUnits="userSpaceOnUse">
          <stop stop-color="#144F21"/>
          <stop offset="0.5" stop-color="#228739"/>
          <stop offset="1" stop-color="#32C353"/>
        </linearGradient>
      </defs>
    </svg>
  `,
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PhxModalUpsellSuccessIconComponent {}
